import { createSelector } from 'reselect'
import { curry } from 'lodash'
import {
  ProductHierarchyEnum,
} from './constants'

const partnerSiteFiltersFunc = state => state.projectCreate.partnerSite.filters
const productHierarchyFunc = state => state.projectCreate.productHierarchy
const partnerSiteFilterSourceFunc = state => state.entities.partner_site_views
const partnerSiteSourceSelector = createSelector(
  partnerSiteFiltersFunc,
  partnerSiteFilterSourceFunc,
  (refs, source) => refs.map(ref => source[ref])
)
const productClassFiltersFunc = state => state.projectCreate.productClass.filters
const productClassFilterSourceFunc = state => state.entities.product_class_type_views
const productClassSourceSelector = createSelector(
  productClassFiltersFunc,
  productClassFilterSourceFunc,
  (refs, source) => {
    if (source)
      return refs.map((ref) => source[ref])
    else
      return []
  }
)

const formatListFunc = (property, sources) => (
  sources.reduce((result, {id, ...rest}) => {
    const key = rest[property] ? rest[property] : ''
    const previous = result[key]
    const updated = previous ? [...previous, id] : [id]
    return {
      ...result,
      [key]: updated
    }
  }, {})
)

export const partnerListSelector = createSelector(
  partnerSiteSourceSelector,
  (sources) => formatListFunc('partner', sources)
)

export const partnerSiteListSelector = createSelector(
  partnerSiteSourceSelector,
  (sources) => formatListFunc('name', sources)
)

export const odmListSelector = createSelector(
  partnerSiteSourceSelector,
  (sources) => formatListFunc('odm', sources)
)

export const productClassListSelector = createSelector(
  productClassSourceSelector,
  (sources) => formatListFunc('productClass', sources)
)

export const productHierarchyListSelector = (() => {
  const sourceSelectorHoc = (type) => {
    return createSelector(
      (state) => state.projectCreate.productHierarchy[type].filters,
      (state) => state.entities.product_children_views,
      (refs, source) => refs.map((ref) => source[ref])
    )
  }

  const selectorList = Object.keys(ProductHierarchyEnum)
    .reduce((result, key) => {
      const name = ProductHierarchyEnum[key].label
      return {
        ...result,
        [name]: createSelector(
          sourceSelectorHoc(name),
          (sources) => formatListFunc('name', sources)
        )
      }
    }, {})


  const getSelector = (type) => {
    return selectorList[type.label]
  }
  return curry((state, type) => getSelector(type)(state))
})()

export const productHierarchyValueSelector = curry((state, type) => {
  return state.uiState.projectCreate.productHierarchy[type.label]
})

export const partnerSiteIdSelector = createSelector(
  partnerSiteFiltersFunc,
  (filters) => filters.length === 1 ? filters[0] : undefined
)

export const productHierarchyIdSelector = createSelector(
  productHierarchyFunc,
  (filterList) => {
    let sku = undefined
    const hasOneProductId = Object.values(filterList)
      .every(({filters}) => filters.length === 1)
    if (hasOneProductId) sku = filterList[ProductHierarchyEnum.SKU.label].filters[0]
    return sku
  }
)

export const productClassIdSelector = createSelector(
  productClassFiltersFunc,
  (filters) => filters.length === 1 ? filters[0] : undefined
)

export const disabledButtonSelector = createSelector(
  partnerSiteIdSelector,
  productHierarchyIdSelector,
  productClassIdSelector,
  (partnerSiteId, productId, productClassId) =>
    partnerSiteId === undefined || productId === undefined || productClassId === undefined
)

export const redirectSelector = state => state.uiState.projectCreate.redirect
export const isValidProjectCreateSelector = disabledButtonSelector
